import HttpService from "./http-service";
import AsyncPaginatedRequest from "./async-paginated-request";
import { LazyAsyncIter } from "@/iterators";
import { pageMapperBuilder, Paginated } from "@/pagination";
import DocumentationExplanationFile from "@/entities/documentation-explanation-file";

export default class DocumentationExplanationFiles extends HttpService {
  public getDocumentationExplanationFiles(
    documentId: string
  ): AsyncIterator<Paginated<DocumentationExplanationFile>> {
    const params = {
      documentId,
    };
    const asyncReq = new AsyncPaginatedRequest<DocumentationExplanationFileDTO>(
      "get",
      "documentations-example-files",
      params,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(asyncReq).map(
      pageMapperBuilder(documentationExplanationFileDTOFromDTO)
    );
  }

  public async insertFile(file: File, documentId: string): Promise<number> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentation_id", documentId);

    const { data } = await this.httpClient.post<number>(
      "/documentations-example-files",
      formData,
      config
    );
    return data;
  }

  public async deleteFile(explanationFileId: number): Promise<void> {
    await this.httpClient.delete<void>(
      `/documentations-example-files/${explanationFileId}`
    );
  }
}

export interface DocumentationExplanationFileDTO {
  id: number;
  name: string;
  slug?: string;
  documentation_id: string;
  file_id: string;
}

export function documentationExplanationFileDTOFromDTO(
  dto: DocumentationExplanationFileDTO
): DocumentationExplanationFile {
  return new DocumentationExplanationFile({
    id: dto.id,
    name: dto.name,
    documentation_id: dto.documentation_id,
    file_id: dto.file_id,
  });
}
